import React from 'react';
import Icon from '../../../components/AppIcon';

const PayrollKPICard = ({ title, value, subtitle, trend, trendValue, icon, status }) => {
  const getStatusStyles = () => {
    switch (status) {
      case 'success':
        return 'bg-success/10 text-success border-success/20';
      case 'warning':
        return 'bg-warning/10 text-warning border-warning/20';
      case 'error':
        return 'bg-error/10 text-error border-error/20';
      default:
        return 'bg-muted text-muted-foreground border-border';
    }
  };

  const getTrendIcon = () => {
    if (trend === 'up') return 'TrendingUp';
    if (trend === 'down') return 'TrendingDown';
    return 'Minus';
  };

  const getTrendColor = () => {
    if (trend === 'up' && status === 'success') return 'var(--color-success)';
    if (trend === 'down' && status === 'error') return 'var(--color-error)';
    return 'var(--color-muted-foreground)';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-4 md:p-6 transition-smooth hover:shadow-md">
      <div className="flex items-start justify-between mb-4">
        <div className="flex-1">
          <p className="caption text-xs md:text-sm text-muted-foreground mb-1">{title}</p>
          <h3 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground data-text">
            {value}
          </h3>
        </div>
        <div className={`flex items-center justify-center w-10 h-10 md:w-12 md:h-12 rounded-md ${getStatusStyles()}`}>
          <Icon name={icon} size={20} color="currentColor" />
        </div>
      </div>

      <div className="flex items-center justify-between">
        <p className="text-xs md:text-sm text-muted-foreground">{subtitle}</p>
        {trendValue && (
          <div className="flex items-center gap-1">
            <Icon name={getTrendIcon()} size={16} color={getTrendColor()} />
            <span className="text-xs md:text-sm font-medium data-text" style={{ color: getTrendColor() }}>
              {trendValue}
            </span>
          </div>
        )}
      </div>
    </div>
  );
};

export default PayrollKPICard;